import { createFileRoute } from "@tanstack/react-router";
import Nyheter from "@/pages/Nyheter";
import { articlesByCategory } from "@/data/articles";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildCollectionSchema, buildPageSchema, buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/nyheter/")({
  head: () =>
    buildSeoHead(publicPageSeo.nyheter, [
      buildPageSchema(publicPageSeo.nyheter, "CollectionPage"),
      buildCollectionSchema(
        publicPageSeo.nyheter,
        articlesByCategory("nyheter").map((article) => article.title),
      ),
      buildBreadcrumbSchema(getBreadcrumbTrail("/nyheter") ?? []),
    ]),
  component: Nyheter,
});
